import { Container } from 'inversify'

import { CricketIncidentId } from '@collector/sportsapi-client-legacy'
import { RelationSportCommonIoCBindings } from '@mobile/views/Relation/Shared/RelationSportCommonDependencies/relationSportCommonDependencies'

export function bindAssignableIncidentConfiguration(ioc: Container): void {
  ioc
    .bind(RelationSportCommonIoCBindings.AssignableIncidentsConfiguration)
    .toDynamicValue(() => {
      return {
        [CricketIncidentId.LegalBall]: {
          participants: { main: 'Current batter', secondary: 'Current bowler' },
          participantsConfiguration: { secondary: { loadOppositeTeam: true } },
        },
        [CricketIncidentId.IllegalBall]: {
          participants: { main: 'Current batter', secondary: 'Current bowler' },
          participantsConfiguration: { secondary: { loadOppositeTeam: true } },
        },
        [CricketIncidentId.Substitution]: {
          participants: { main: 'Out', secondary: 'In' },
        },
      }
    })
    .inSingletonScope()
}
